import { render, staticRenderFns } from "./CounselorTableTabs.vue?vue&type=template&id=06ff8fd7&"
import script from "./CounselorTableTabs.vue?vue&type=script&lang=js&"
export * from "./CounselorTableTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports